import React from "react";
import styled from "styled-components";

const Path = styled.path`
  stroke: ${props => props.theme.icon};
  fill: ${props => (props.selected ? props.theme.icon : "none")};
`;

const KpiIcon = ({ selected }) => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30.758"
        height="29.758"
        viewBox="0 0 30.758 29.758"
      >
        <Path
          selected={selected}
          d="M333.668,268.846c5.812-1.544,10.27-4.051,11.8-8.639,2.978-7.739,8.476-12.188,16.957-12.342v23.242H333.668V242.349"
          transform="translate(-332.668 -242.349)"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.5"
        height="18"
        viewBox="0 0 18.5 18"
      >
        <Path
          selected={selected}
          d="M333.668,258.473c3.537-.94,6.25-2.465,7.181-5.257,1.812-4.709,5.158-7.417,10.319-7.51v14.143h-17.5v-17.5"
          transform="translate(-333.168 -242.349)"
        />
      </svg>
    );
  }
};

export default KpiIcon;
